import {
  BoxGeometry,
  Color,
  Material,
  Mesh,
  MeshBasicMaterial,
  Object3D,
  Quaternion,
  SphereGeometry,
  Vector3,
} from "three";

const redBasicMaterial = new MeshBasicMaterial({
  color: new Color(1.0, 0.0, 0.0),
});
const greenBasicMaterial = new MeshBasicMaterial({
  color: new Color(0.0, 1.0, 0.0),
});
const blueBasicMaterial = new MeshBasicMaterial({
  color: new Color(0.0, 0.0, 1.0),
});

export const fetchAllMaterials = (object: Object3D) => {
  const materials: Material[] = [];
  if (object instanceof Mesh) materials.push(object.material);

  object.traverse((o) => {
    if (o instanceof Mesh && materials.indexOf(o.material) < 0) {
      materials.push(o.material);
    }
  });
  return materials;
};

export const fetchMaterialObjectMap = (object: Object3D) => {
  const map = new Map<Material, Object3D[]>();
  if (object instanceof Mesh) map.set(object.material, [object]);

  object?.traverse((o) => {
    if (o instanceof Mesh) {
      const objectArr = map.get(o.material) || [];
      map.set(o.material, objectArr);
      objectArr.push(o);
    }
  });

  return map;
};

const units = { cm: 100, m: 1 };
export const stringPositionToVector = (
  position: string
): Vector3 | undefined => {
  if (!position) return undefined;
  const matches = [...position.matchAll(/(-?\.?\d+(?:\.\d+)?)(cm|m)?/g)];

  const values = matches.map((match) => {
    const value = parseFloat(match[1]);
    const unit = (units as any)[match[2] || "m"] as number;
    return unit * value;
  });

  return new Vector3(values[0], values[1], values[2]);
};

export const saveTransform = (object: Object3D) => {
  const savedTransform = object.userData["savedTransform"] || {
    parent: undefined,
    position: new Vector3(),
    rotation: new Quaternion(),
    scale: new Vector3(1, 1, 1),
  };

  savedTransform.parent = object.parent;
  savedTransform.position.copy(object.position);
  savedTransform.rotation.copy(object.quaternion);
  savedTransform.scale.copy(object.scale);

  object.userData["savedTransform"] = savedTransform;
};

export const resetTransform = (object: Object3D) => {
  object.position.set(0, 0, 0);
  object.scale.set(1, 1, 1);
  object.quaternion.set(0, 0, 0, 1);
};

export const restoreTransform = (object: Object3D) => {
  const savedTransform = object.userData["savedTransform"];
  savedTransform.parent?.add(object);
  object.position.copy(savedTransform.position);
  object.quaternion.copy(savedTransform.rotation);
  object.scale.copy(savedTransform.scale);
};

export const createAxis = () => {
  const linewidth = 0.0025;
  const lineheight = 0.1;
  const object = new Mesh(
    new SphereGeometry(0.025),
    new MeshBasicMaterial({ color: 0xff0000 })
  );

  object.add(
    new Mesh(
      new BoxGeometry(lineheight, linewidth, linewidth).translate(
        0.5 * lineheight,
        0,
        0
      ),
      redBasicMaterial
    )
  );

  object.add(
    new Mesh(
      new BoxGeometry(linewidth, lineheight, linewidth).translate(
        0,
        0.5 * lineheight,
        0
      ),
      greenBasicMaterial
    )
  );

  object.add(
    new Mesh(
      new BoxGeometry(linewidth, linewidth, lineheight).translate(
        0,
        0,
        0.5 * lineheight
      ),
      blueBasicMaterial
    )
  );
  return object;
};
